import { render, staticRenderFns } from "./quote-details-view.vue?vue&type=template&id=1a9964c5&scoped=true&"
import script from "./quote-details-view.vue?vue&type=script&lang=js&"
export * from "./quote-details-view.vue?vue&type=script&lang=js&"
import style0 from "./quote-details-view.vue?vue&type=style&index=0&id=1a9964c5&scoped=true&lang=css&"
import style1 from "./quote-details-view.vue?vue&type=style&index=1&id=1a9964c5&lang=scss&scoped=true&"
import style2 from "./quote-details-view.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9964c5",
  null
  
)

export default component.exports